import { useTranslation } from "react-i18next";
import { FormAutocomplete } from "../fields";
import {SyntheticEvent, useCallback, useContext} from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import {IFormValues} from "../../pages/insert/types";
import {ILocation} from "../../types";
import {useFormContext} from "react-hook-form";

interface TenantFormProperties {
    name: string,
    control?: any,
    multiple?: boolean
    onChange?: any,
    disabled?: boolean
}
const TenantForm = ({
    name,
    multiple = true,
    onChange,
    disabled = false
}: TenantFormProperties) => {

    const { t } = useTranslation(['booking', 'translation']);
    const { globalData } = useContext(GlobalContext);

    return (
        <FormAutocomplete
            name={name}
            label={t("label.tenant") + ' *'} 
            options={globalData?.user.legalEntities?.map((elem: any) => elem.name) || []}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            renderOption={(props, option) =>
                <li {...props} key={option}>
                    {t('translation:legalEntities.'.concat(option))}
                </li>
            }
        />
    )

}

export default TenantForm;